<template>
  <v-row>
    <v-col>
      <v-btn
        text
        @click="goProfil">Profil</v-btn>
      <v-menu
        v-if="(parent === 'false')"
        offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
          >
            Facturare
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            @click="goFact"
          >
            <v-list-item-title>Informatii facturare</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        text
        @click="goSeo">Optimizare</v-btn>
    </v-col>
  </v-row>
</template>
<script>
import router from '@/router'
export default {
  name: 'MenuProfil',
  data () {
    return {
      parent: localStorage.getItem('parent')
    }
  },
  methods: {
    goProfil () {
      router.push({path: '/profil'})
    },
    goFact () {
      router.push({path: '/factinfo'})
    },
    goSeo () {
      router.push({path: '/seo'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profil/MenuProfil.vue